import React from "react";
import {Box, Checkbox, CircularProgress, IconButton, Popover} from "@mui/material";
import Map, {Marker} from 'react-map-gl';
import DpeCtrl from "../svc/openapi/DpeCtrl";
import {computeSurfUtile} from "../component/RightAccordion";

const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';

export default function MapVeoliaPage({codeInsee}) {

    const [centroid, setCentroid] = React.useState([-0.618945, 44.774267]);
    const [zoom, setZoom] = React.useState(12);
    const [loading, setLoading] = React.useState(true);
    const [elementsOfMap, setElementsOfMap] = React.useState({});

    const [r, setR] = React.useState(true);
    const [t, setT] = React.useState(true);
    const [i, setI] = React.useState(true);
    const [a, setA] = React.useState(true);

    const [selectedItem, setSelectedItem] = React.useState(undefined);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);


    React.useEffect(() => {

        DpeCtrl.getVeoliaCsvIdGet(codeInsee, (resCsv) => {
            DpeCtrl.getVeoliaBdnbIdGet(codeInsee, (resBdnb) => {
                setLoading(false)
                let elements = {};

                let lat = 0;
                let long = 0;
                let nb = 0;
                resCsv.forEach((csv) => {
                    let banId = csv["BAN"];
                    if (!elements[banId]) {
                        elements[banId] = {
                            ...csv,
                            listBdnb: [],
                            listNRJ: [],
                            isVisible: true,
                            PDL: 0,
                            conso: 0,

                        };

                    }
                    elements[banId].PDL = elements[banId].PDL + Number(csv["PDL"]);
                    elements[banId].conso = elements[banId].conso + Number(csv["CONSO"]);
                    elements[banId].listNRJ.push(csv);
                    lat += Number(csv["latitude"]);
                    long += Number(csv["longitude"]);
                    nb++;
                })
                resBdnb.forEach((bdnb) => {

                    let banId = bdnb["adresse.cle_interop_adr"];
                    /*if (!elements[banId]) {
                        elements[banId] = {
                            ...bdnb,
                            lat: geoJson.coordinates[1],
                            long: geoJson.coordinates[0],
                            listBdnb: [],
                            listNRJ: [],
                            isVisible: false,
                            conso: 0,
                            pdl: 0
                        };
                    }*/
                    if (elements[banId]) {
                        elements[banId].listBdnb.push(bdnb);
                    }
                })
                setElementsOfMap(elements);
                setLoading(false);
                setCentroid([long / nb, lat / nb]);
            })
        })
    }, [])

    const mapRef = React.useCallback(mapR => {
        if (mapR) {
        }
    }, []);


    React.useEffect(() => {
        if (elementsOfMap) {
            let elements = {};
            Object.keys(elementsOfMap).forEach((banId) => {
                if (elementsOfMap[banId]["CODE_GRAND_SECTEUR"] === "R") {
                    if (r) {
                        elementsOfMap[banId].isVisible = true;
                    } else {
                        elementsOfMap[banId].isVisible = false;
                    }

                } else if (elementsOfMap[banId]["CODE_GRAND_SECTEUR"] === "T") {
                    if (t) {
                        elementsOfMap[banId].isVisible = true;
                    } else {
                        elementsOfMap[banId].isVisible = false;
                    }
                } else if (elementsOfMap[banId]["CODE_GRAND_SECTEUR"] === "I") {
                    if (i) {
                        elementsOfMap[banId].isVisible = true;
                    } else {
                        elementsOfMap[banId].isVisible = false;
                    }
                }

                elements[banId] = elementsOfMap[banId];
            });
            setElementsOfMap({...elements});
        }
    }, [r, t, i]);

    function produceKpiView(selectedItem) {
        if (selectedItem) {
            let elem = elementsOfMap[selectedItem];
            let listBdnb = elem.listBdnb;

            let batiment_groupe_geom_cstr = 0;
            let suc = 0;
            let nbLog = 0;//batiment_groupe_ffo_bat.nb_log
            let usage1 = {};//batiment_groupe_ffo_bat.usage_niveau_1_txt
            if (listBdnb && listBdnb.length > 0) {
                listBdnb.forEach((bdnb) => {
                    batiment_groupe_geom_cstr = batiment_groupe_geom_cstr + Number(bdnb["batiment_construction.s_geom_cstr"]);
                    usage1[bdnb["batiment_groupe_ffo_bat.usage_niveau_1_txt"]] = true;
                    suc = +computeSurfUtile(bdnb["batiment_construction.hauteur"], bdnb["batiment_construction.s_geom_cstr"],bdnb["batiment_groupe_ffo_bat.annee_construction"]);
                    nbLog = +Number(bdnb["batiment_groupe_ffo_bat.nb_log"]);
                })
            }

            return (<Box sx={{width: 400, margin: 2, overflow: "hidden"}}>
                <Box>{elem["BAN"]}</Box>
                <Box>{elem["ADRESSE"]}</Box>
                <Box>{elem["CODE_GRAND_SECTEUR"]}</Box>
                <Box>{elem["CODE_SECTEUR_NAF2_LIBELLE"]}</Box>
                <Box>{elem["OPERATEUR"]}</Box>
                <Box>pdl : {elem["PDL"]}</Box>
                <Box>{elem["CONSO"]} MW/H</Box>
                {listBdnb && listBdnb.length > 0 &&
                    <Box>
                        <Box>cstr : {batiment_groupe_geom_cstr} m²</Box>
                        <Box>SUC : {suc}</Box>
                        <Box>nbLog : {nbLog}</Box>
                        <Box>usage1 : {Object.keys(usage1).join(', ')}</Box>
                    </Box>}
            </Box>)
        }
    }

    function getColorConso(elementsOfMapElement) {
        if (elementsOfMapElement.conso < 100) {
            return "#00ffc4"
        } else if (elementsOfMapElement.conso < 200) {
            return "#7bff00"
        } else if (elementsOfMapElement.conso < 400) {
            return "#f7ff00"
        } else if (elementsOfMapElement.conso < 800) {
            return "#ffb700"
        } else if (elementsOfMapElement.conso < 1000) {
            return "#ff7300"
        } else {

            return "#ff1818"
        }
    }

    function getSizeConso(elementsOfMapElement) {
        if (elementsOfMapElement.conso < 100) {
            return 10
        } else if (elementsOfMapElement.conso < 200) {
            return 15
        } else if (elementsOfMapElement.conso < 400) {
            return 20
        } else if (elementsOfMapElement.conso < 800) {
            return 25
        } else if (elementsOfMapElement.conso < 1000) {
            return 30
        } else {
            return 40
        }
    }

    if (loading) {
        return (<Box sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center"
        }}>
            <CircularProgress/>
        </Box>)
    } else {
        return (
            <Box sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>
                <Box sx={{height: "5vh"}}>
                    <Box sx={{width: "20vw"}}/>
                    <Box sx={{width: "60vw", display: "flex"}}>
                        <Box>
                            <Checkbox sx={{p: 0}} size="small" checked={r} onClick={() => {
                                setR(!r);
                            }}/>
                            R
                        </Box>
                        <Box>
                            <Checkbox sx={{p: 0}} size="small" checked={t} onClick={() => {
                                setT(!t);
                            }}/>
                            T
                        </Box>
                        <Box>
                            <Checkbox sx={{p: 0}} size="small" checked={i} onClick={() => {
                                setI(!i);
                            }}/>
                            I
                        </Box>

                    </Box>
                    <Box sx={{width: "20vw"}}/>
                </Box>
                <Box sx={{width: "100vw", height: "95vh", display: "flex"}}>
                    <Box sx={{width: "20vw", height: "95vh"}}/>
                    <Box sx={{width: "60vw", height: "95vh"}}>
                        <Box sx={{width: "60vw", height: "70vh"}}>
                            <Map
                                ref={mapRef}
                                initialViewState={{
                                    longitude: centroid[0], latitude: centroid[1], zoom: zoom
                                }}
                                mapStyle="mapbox://styles/mapbox/streets-v9"
                                mapboxAccessToken={MAPBOX_TOKEN}
                            >
                                {elementsOfMap && Object.keys(elementsOfMap).map((banId, index) => {
                                    if (elementsOfMap[banId].isVisible) {
                                        return (<Marker key={index}
                                                        longitude={elementsOfMap[banId].longitude}
                                                        latitude={elementsOfMap[banId].latitude}
                                                        anchor="bottom">
                                            <IconButton size="small"
                                                        sx={{
                                                            color: "#fff",
                                                            backgroundColor: getColorConso(elementsOfMap[banId]),
                                                            borderStyle: "solid",
                                                            borderColor: "#000",
                                                            borderRadius: 20,//getBorderRadius(elementsOfMap[banId]),
                                                            borderWidth: 1.5,
                                                            width: getSizeConso(elementsOfMap[banId]),
                                                            height: getSizeConso(elementsOfMap[banId]),
                                                            '&:hover': {
                                                                backgroundColor: getColorConso(elementsOfMap[banId]),
                                                                borderStyle: "solid",
                                                                borderColor: "#000",//purple[700],
                                                                borderRadius: 20,//getBorderRadius(elementsOfMap[banId]),
                                                                borderWidth: 3,
                                                            },
                                                        }}
                                                        onClick={(e) => {
                                                            setSelectedItem(banId);
                                                            handleClick(e);
                                                        }}
                                            >
                                            </IconButton>
                                        </Marker>)
                                    }
                                })
                                }
                            </Map>
                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom', horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top', horizontal: 'center',
                                }}
                            >
                                {produceKpiView(selectedItem)}
                            </Popover>

                        </Box>
                    </Box>
                </Box>
            </Box>)
    }
}
